/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description PatientEvent Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { patientEvent: patientEventEndpoints } = endpoints;

export class PatientEventService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get patientEvents list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get patientEvents list.
   */
  getPatientEvents = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = patientEventEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get patientEvent info by id
   * @param { string } id - PatientEvent id.
   * @return { Object } - Get patientEvents list.
   */
  getPatientEventById = async (id) => {
    const url = `${patientEventEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Create patientEvent
   * @param { string } name - PatientEvent name.
   * @param { string } description - PatientEvent description.
   * @return { promise } - The patientEvent promise object.
   */
  createPatientEvent = async (
    description,
    event_type,
    patient,
    register_date,
    end_date,
    phone_number
  ) => {
    const body = {
      description,
      event_type,
      patient,
      register_date,
      end_date,
      phone_number
    };
    const url = patientEventEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Delete patientEvent by id
   * @param { string } id - PatientEvent id.
   * @return { Object } - Get patientEvents list.
   */
  deletePatientEventById = async (id) => {
    const url = `${patientEventEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Update patientEvent
   * @param { string } name - PatientEvent name.
   * @param { string } description - PatientEvent description.
   * @param { string } id - PatientEvent id.
   * @return { promise } - The patientEvent promise object.
   */
  updatePatientEvent = async (
    id_patient_event,
    description,
    event_type,
    patient,
    register_date,
    end_date,
    phone_number
  ) => {
    const body = {
      id_patient_event,
      description,
      event_type,
      patient,
      register_date,
      end_date,
      phone_number
    };
    const url = `${patientEventEndpoints.base}/${id_patient_event}`;
    return this.http.update(url, body, {}, 'put');
  };

  /**
   * Get eventTypes list with pagination
   * @return { Object } - Get event types list.
   */
  getEventTypes = async () => {
    const url = patientEventEndpoints.eventTypes;
    return this.http.get(url);
  };
}

export default new PatientEventService(externalConnector);
